import MapPoint from './MapPoint'

export default MapPoint
